// extracted by mini-css-extract-plugin
module.exports = {"notFound__subtitle":"NotFound_notFound__subtitle__7dDLH"};